import { useField } from 'formik'
import React from 'react'
import { Textarea } from '@mantine/core'

interface Props {
  placeholder?: string;
  name: string;
  rows?: number;
  label?: string;
  minRows?: number;
}

export default function MyTextArea (props: Props) {
  const [field, meta] = useField(props.name)
  return (
    <Textarea
      {...field}
      {...props}
      error={meta.touched && meta.error}
      minRows={props.minRows ?? props.rows ?? 3}
      sx={{ marginBottom: 12 }}
    />
  )
}
